<div class="container" *ngIf="clientTranslationKey != null">
	<div class="translation-details">
		<b
			><h3>{{ clientTranslationKey.key }}</h3></b
		>
		<div>
			<div>
				<p><b>Client Type:</b> {{ clientTranslationKey.clientTypeName }}</p>
			</div>
		</div>
	</div>

	<div *ngIf="updateFormLanguagesFormArray.length == clientTranslationKey.languages.length">
		<form [formGroup]="translationUpdateForm">
			<div
				fxLayoutAlign="row stretch"
				fxLayoutGap="20px"
				*ngFor="let language of clientTranslationKey.languages; let i = index"
			>
				<div fxFlex="20%">
					<ahs-text
						id="languageCode"
						[ahsFormGroup]="translationKeyLanguagesControlArray[i]"
						appearance="outline"
						label="Language Code"
					>
					</ahs-text>
				</div>

				<div fxFlex="80%">
					<ahs-textarea
						id="translatedText"
						type="text"
						tabOrder="1"
						[ahsFormGroup]="translationKeyLanguagesControlArray[i]"
						label="Translated Text"
						appearance="outline"
						floatLabel="floatLabel"
					>
					</ahs-textarea>
				</div>
			</div>
			<!--DO stuff with the records-->
			<div>
				<div fxLayoutAlign="row stretch" fxLayoutGap="20px">
					<!--Save Language Changes Button-->
					<div fxFlex="33%">
						<button mat-raised-button [disabled]="!allowSave()" (click)="postChanges()">
							<fa-icon [icon]="$any(['fass', 'window-close'])"></fa-icon>
							Save Changes
						</button>
					</div>

					<div fxFlex="33%">
						<button
							mat-raised-button
							class="danger-btn"
							[disabled]="!outstandingLanguageEdits"
							(click)="resetTranlationFormValues()"
						>
							<fa-icon [icon]="$any(['fass', 'window-close'])"></fa-icon>
							Clear Changes
						</button>
					</div>

					<div fxFlex="33%">
						<button
							mat-raised-button
							[disabled]="outstandingLanguageEdits"
							(click)="createAndReTranslateProvidedEnglishKeys(clientTranslationKey)"
						>
							<fa-icon [icon]="$any(['fass', 'window-close'])"></fa-icon>
							Translate
						</button>
					</div>
				</div>
			</div>
		</form>

		<!-- Portal Pages Section -->
		<div
			*ngIf="clientTranslationKey.portalPages && clientTranslationKey.portalPages.length > 0"
			style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #e0e0e0"
		>
			<h4 style="margin-bottom: 15px">Portal Pages</h4>
			<div
				*ngFor="let portalPage of clientTranslationKey.portalPages"
				style="margin-bottom: 15px; padding: 15px; background-color: #f5f5f5; border-radius: 4px"
			>
				<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">
					<div fxFlex="70%">
						<span style="color: #666; font-size: 13px">Page Name: </span>
						<strong style="font-size: 14px">{{ portalPage.pageName }}</strong>
					</div>
					<div fxFlex="30%">
						<mat-form-field appearance="outline" style="width: 100%">
							<mat-label>Status</mat-label>
							<mat-select
								[value]="portalPage.isActive"
								(selectionChange)="
									updatePortalPageIsActive(portalPage.pageNameClientLanguageId, $event.value)
								"
							>
								<mat-option [value]="true">Enabled</mat-option>
								<mat-option [value]="false">Disabled</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
